import { UIMatch, generatePath } from 'react-router'

import { CsRoute } from './types'
import { Link } from '@mui/material'
import { prepareRoutes } from './utils/prepareRoutes'
import { routePaths } from './route-paths'

export const useOrganizationFileTransferRoutes = () => {
	const routes = prepareRoutes([useOrganizationFtpConfigurations(), useOrganizationEncryptionConfigurations()], {
		stripLeading: `${routePaths.organizations.edit.fileTransfer.path}/`,
	})

	return routes
}

export const useOrganizationFtpConfigurations = (): CsRoute => {
	return {
		path: routePaths.organizations.edit.fileTransfer.ftpConfigurations.path,
		handle: {
			crumb: (data: UIMatch<any, any>) => (
				<Link
					href={generatePath(routePaths.organizations.edit.fileTransfer.ftpConfigurations.path, {
						id: data.params.id ?? '',
					})}
				>
					FTP Configurations
				</Link>
			),
		},
		lazy: () =>
			import('pages/organization-ftp-configurations/organization-ftp-configurations').then((module) => ({
				Component: module.default,
			})),
	}
}

export const useOrganizationEncryptionConfigurations = (): CsRoute => {
	return {
		path: routePaths.organizations.edit.fileTransfer.encryptionConfigs.path,
		handle: {
			crumb: (data: UIMatch<any, any>) => (
				<Link
					href={generatePath(routePaths.organizations.edit.fileTransfer.encryptionConfigs.path, {
						id: data.params.id ?? '',
					})}
				>
					Encryption Settings
				</Link>
			),
		},
		lazy: () =>
			import('pages/organization-encryption-configs').then((module) => ({
				Component: module.default,
			})),
	}
}
